// API Configuration for LaViola.it
export const API_CONFIG = {
  // Production API
  BASE_URL: 'https://www.laviola.it',
  API_URL: 'https://www.laviola.it/api',
  
  // Endpoints
  POSTS: '/app/posts',
  SEARCH: '/app/search',
  TTS: '/tts/synthesize',
  
  // Match endpoints
  matchCommentaries: (matchId: string) => `/match/${matchId}/commentaries`,
  matchStatistics: (matchId: string) => `/match/${matchId}/statistics`,
  matchSummary: (matchId: string) => `/match/${matchId}/summary`,
  matchLineups: (matchId: string) => `/match/${matchId}/lineups`,
};

export const APP_CONFIG = {
  name: 'LaViola.it',
  description: 'Notizie Fiorentina',
  logoUrl: 'https://laviola.s3.eu-south-1.wasabisys.com/img-3178.jpg',
};
